import { actionTypes } from './OverlayLayerConstants';
import { LOGOUT_SUCCESS } from '../../shared/constants/SharedConstants';

const initialStore = {
  openLayers: []
};

export default function OverlayLayerReducer(state = initialStore, action) {
  let editedState;
  const duplicateState = () => (Object.assign({}, state));

  switch (action.type) {
    case actionTypes.OPEN_LAYER_SUCCESS:
      editedState = duplicateState();
      editedState.openLayers = [...editedState.openLayers, { source: action.source, onClick: action.onOverlayClick }];
      break;
    case actionTypes.CLOSE_LAYER_SUCCESS:
      editedState = duplicateState();
      editedState.openLayers = editedState.openLayers.filter(element => element.source !== action.source);
      break;
    case LOGOUT_SUCCESS:
      editedState = duplicateState();
      editedState = initialStore;
      break;
    default:
      return state;
  }

  return editedState;
}



// WEBPACK FOOTER //
// ./src/redux/overlayLayer/OverlayLayerReducer.js